import React from "react"
import {
  CustomReasonCode,
  Maybe,
  Reason as OperationReason
} from "lib/types/generated/graphql-types"
import { Cause, Container } from "./Reason.styled"

type Props = {
  reason: OperationReason
  getCustomCode: (code: Maybe<string> | undefined) => CustomReasonCode
}

const Reason = ({ reason, getCustomCode }: Props) => {
  const customCode = getCustomCode(reason?.code)

  return (
    <Container>
      <div>{customCode ? `${customCode.code} - ${customCode.label}` : reason?.code}</div>
      <Cause>{reason.cause}</Cause>
    </Container>
  )
}

export default Reason
